// src/Components/NavComponents/BottomNav.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useTheme } from '@mui/material';

const BottomNav = ({ navValue }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    switch (newValue) {
      case 0:
        navigate('/home');
        break;
      case 1:
        navigate('/spot');
        break;
      case 2:
        navigate('/futures');
        break;
      case 3:
        navigate('/assets');
        break;
      default:
        break;
    }
  };

  return (
    <BottomNavigation
      sx={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        bgcolor: theme.palette.background.navbar,
        color: theme.palette.text.primary,
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
        borderTop: `1px solid ${theme.palette.divider || theme.palette.text.secondary}`,
        transition: 'all 0.3s ease-in-out',
      }}
      value={navValue}
      onChange={handleChange}
    >
      <BottomNavigationAction
        label="Home"
        icon={<HomeIcon />}
        sx={{
          color: navValue === 0 ? theme.palette.brand.main : theme.palette.text.secondary,
          minWidth: 0,
          '& .MuiBottomNavigationAction-label': { fontSize: 12, fontWeight: 500 },
        }}
      />
      <BottomNavigationAction
        label="Spot"
        icon={<ShowChartIcon />}
        sx={{
          color: navValue === 1 ? theme.palette.brand.main : theme.palette.text.secondary,
          minWidth: 0,
          '& .MuiBottomNavigationAction-label': { fontSize: 12, fontWeight: 500 },
        }}
      />
      <BottomNavigationAction
        label="Futures"
        icon={<TrendingUpIcon />}
        sx={{
          color: navValue === 2 ? theme.palette.brand.main : theme.palette.text.secondary,
          minWidth: 0,
          '& .MuiBottomNavigationAction-label': { fontSize: 12, fontWeight: 500 },
        }}
      />
      <BottomNavigationAction
        label="Assets"
        icon={<AccountBalanceWalletIcon />}
        sx={{
          color: navValue === 3 ? theme.palette.brand.main : theme.palette.text.secondary,
          minWidth: 0,
          '& .MuiBottomNavigationAction-label': { fontSize: 12, fontWeight: 500 },
        }}
      />
    </BottomNavigation>
  );
};

export default BottomNav;